import { LOCALE } from './constants';
export const FORMAT_DATE = {
    en: (date) => {
        return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    },
    cs: (date) => {
        return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
    },
};
// TODO unit test
export const VALIDATE_DATE = {
    en: (dateString, minDay, maxDay) => {
        const dateArray = dateString.split('/'), month = new Date(parseInt(dateArray[2], 10), parseInt(dateArray[0], 10) - 1, 1);
        let date = null;
        if (dateArray.length === 3 &&
            validateYear(dateArray[2]) &&
            validateMonth(dateArray[0]) &&
            validateDay(dateArray[1], month)) {
            date = PARSE_DATE.en(dateString);
        }
        return date && validateDateRange(date, minDay, maxDay) ? date : null;
    },
    cs: (dateString, minDay, maxDay) => {
        const dateArray = dateString.split('.'), month = new Date(parseInt(dateArray[2], 10), parseInt(dateArray[1], 10) - 1, 1);
        let date = null;
        if (dateArray.length === 3 &&
            validateYear(dateArray[2]) &&
            validateMonth(dateArray[1]) &&
            validateDay(dateArray[0], month)) {
            date = PARSE_DATE.cs(dateString);
        }
        return date && validateDateRange(date, minDay, maxDay) ? date : null;
    },
};
export const validateDateRange = (currentDay, minDay, maxDay) => {
    const current = new Date(currentDay.getFullYear(), currentDay.getMonth(), currentDay.getDate());
    if (minDay) {
        const min = new Date(minDay.getFullYear(), minDay.getMonth(), minDay.getDate());
        if (!(min <= current)) {
            return false;
        }
    }
    if (maxDay) {
        const max = new Date(maxDay.getFullYear(), maxDay.getMonth(), maxDay.getDate());
        if (!(current <= max)) {
            return false;
        }
    }
    return true;
};
// TODO unit test
export const PARSE_DATE = {
    en: (dateString) => {
        return new Date(dateString);
    },
    cs: (dateString) => {
        const dateArray = dateString.split('.');
        return new Date(+dateArray[2], +dateArray[1] - 1, +dateArray[0]);
    },
};
export const validateDay = (day, date) => {
    const dayInt = parseInt(day, 10), daysInMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    return /^\d{1,2}$/.test(day) && dayInt >= 1 && dayInt <= daysInMonth;
};
export const validateMonth = (month) => {
    const monthInt = parseInt(month, 10);
    return /^\d{1,2}$/.test(month) && monthInt >= 1 && monthInt <= 12;
};
export const validateYear = (year) => {
    return /^\d{4}$/.test(year);
};
export const getLanguage = (windowNavigatorLanguage) => {
    const lang = windowNavigatorLanguage.split('-');
    switch (lang[0]) {
        case 'cs':
            return LOCALE.CS;
        default:
            return LOCALE.EN;
    }
};
export const isDateValid = (date) => {
    return date instanceof Date && !!date.getTime(); // date.getTime() testuje zda neprisla hodnota "Invalid Date"
};
// Date
export var DATE_TIME_FORMAT;
(function (DATE_TIME_FORMAT) {
    DATE_TIME_FORMAT["MONTH_LONG"] = "MONTH_LONG";
    DATE_TIME_FORMAT["YEAR_NUMERIC"] = "YEAR_NUMERIC";
})(DATE_TIME_FORMAT || (DATE_TIME_FORMAT = {}));
export const DATE_TIME_FORMAT_OPTIONS = {
    MONTH_LONG: { month: 'long' },
    YEAR_NUMERIC: { year: 'numeric' },
};
const dateTimeFormatCache = {};
export const getDateTimeFormat = (format) => (lang) => {
    let formats = dateTimeFormatCache[lang];
    if (!formats) {
        formats = {};
        dateTimeFormatCache[lang] = formats;
    }
    let formatter = formats[format];
    if (!formatter) {
        formatter = new Intl.DateTimeFormat(lang, DATE_TIME_FORMAT_OPTIONS[format]);
    }
    return formatter;
};
export const formatMonthLong = (lang, date) => getDateTimeFormat(DATE_TIME_FORMAT.MONTH_LONG)(lang).format(date);
export const formatYear = (lang, date) => getDateTimeFormat(DATE_TIME_FORMAT.YEAR_NUMERIC)(lang).format(date);
//# sourceMappingURL=utils.js.map